var NuveiEnvironment;
(function (NuveiEnvironment) {
    NuveiEnvironment["INTEGRATION"] = "int";
    NuveiEnvironment["PRODUCTION"] = "prod";
})(NuveiEnvironment || (NuveiEnvironment = {}));
var NuveiMethodType;
(function (NuveiMethodType) {
    NuveiMethodType["DEPOSIT"] = "DEPOSIT";
    NuveiMethodType["WITHDRAWAL"] = "WITHDRAWAL";
})(NuveiMethodType || (NuveiMethodType = {}));

export { NuveiEnvironment, NuveiMethodType };
